import { render } from "./GamerSalary.vue?vue&type=template&id=a9c88e22&scoped=true"
import script from "./GamerSalary.vue?vue&type=script&lang=js"
export * from "./GamerSalary.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-a9c88e22"

export default script